// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fh","advertDetailServiceList__header":"c-o_fi","advertDetailServiceList__list":"c-o_fj"};